"use client";

import Link from "next/link";
import { openConsentSettings } from "@/lib/consent";
import { useCompany } from "./CompanyProvider";

export default function Footer() {
  const { phone, phoneHref, email } = useCompany();
  return (
    <footer id="contact" className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold text-white mb-3">Autobook</h3>
            <p className="text-sm leading-relaxed">
              Patikimi automobiliai nuomai. Paprasta ir greita rezervacija internetu.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">
              Kontaktai
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href={phoneHref} className="hover:text-white transition-colors">
                  {phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${email}`} className="hover:text-white transition-colors">
                  {email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">
              Informacija
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/taisykles" className="hover:text-white transition-colors">
                  Paslaugos taisyklės
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="hover:text-white transition-colors">
                  Privatumo politika
                </Link>
              </li>
              <li>
                <Link href="/slapukai" className="hover:text-white transition-colors">
                  Slapukų politika
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openConsentSettings}
                  className="hover:text-white transition-colors text-left"
                >
                  Slapukų nustatymai
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 text-center text-xs text-gray-500">
          &copy; {new Date().getFullYear()} Autobook. Visos teisės saugomos.
        </div>
      </div>
    </footer>
  );
}
